import { dynamicLoadUpgradeQueries } from '../utils';
export const isSameProductFamilyQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    getCurrentProduct
  } = await dynamicLoadUpgradeQueries(httpClient);
  const {
    currentProduct
  } = await getCurrentProduct({});
  return {
    isSameProductFamily: (currentProduct == null ? void 0 : currentProduct.productFamilyId) === request.product.productFamilyId
  };
};
//# sourceMappingURL=isSameProductFamily.query.js.map